import React, {
  useEffect,
  useState,
  useRef
} from "react";

import { FaEye } from "react-icons/fa";

import ReactDOM from "react-dom";
import axios from "axios";

// import "./AllTickets.css";
import "./Support.css";

const API =
  "https://api.mahal.qa/api/v1/admin/support";

export default function MyTickets() {

  /* ======================================================
     STATE
  ====================================================== */

  const [tickets, setTickets] =
    useState([]);

  const [cursor, setCursor] =
    useState(null);

  const [loading, setLoading] =
    useState(false);

  const [hasMore, setHasMore] =
    useState(true);

  const [search, setSearch] =
    useState("");

  const [debouncedSearch,
    setDebouncedSearch] =
    useState("");

  const [status, setStatus] =
    useState("");

  const [priority, setPriority] =
    useState("");

  const [selectedTicket,
    setSelectedTicket] =
    useState(null);

  const [modalOpen,
    setModalOpen] =
    useState(false);

  const [replyMessage,
    setReplyMessage] =
    useState("");

  const [internalNote,
    setInternalNote] =
    useState("");

  const [attachmentUrls,
    setAttachmentUrls] =
    useState({});
  const [previewFile,
    setPreviewFile] =
    useState(null);

  const [admins, setAdmins] =
    useState([]);

  const containerRef = useRef();

  /* ======================================================
     AUTH
  ====================================================== */

  const ADMIN_TOKEN =
    localStorage.getItem(
      "admin_token"
    );

  const ADMIN_ROLE =
    (
      localStorage.getItem(
        "admin_role"
      ) || ""
    ).toUpperCase();

  const ADMIN_ID =
    localStorage.getItem(
      "admin_id"
    );

  if (!ADMIN_TOKEN) {


  }

  if (
    ADMIN_ROLE !== "SUPPORT_ADMIN"
    &&
    ADMIN_ROLE !== "OPS_ADMIN"
  ) {


  }

  const headers = {
    Authorization:
      `Bearer ${ADMIN_TOKEN}`
  };

  /* ======================================================
     SEARCH DEBOUNCE
  ====================================================== */

  useEffect(() => {

    const t = setTimeout(() => {

      setDebouncedSearch(
        search
      );

    }, 400);

    return () =>
      clearTimeout(t);

  }, [search]);

  /* ======================================================
     FETCH ADMINS
  ====================================================== */

  const fetchAdmins = async () => {

    try {

      const res =
        await axios.get(
          `${API}/admins`,
          { headers }
        );

      setAdmins(
        res.data || []
      );

    } catch (err) {

      console.error(err);
    }
  };

  /* ======================================================
     FETCH TICKETS
  ====================================================== */

  const fetchTickets = async (
    reset = false
  ) => {

    if (loading) {
      return;
    }

    try {

      setLoading(true);

      const res =
        await axios.get(
          `${API}/tickets`,
          {
            headers,

            params: {

              cursor:
                reset
                  ? null
                  : cursor,

              search:
                debouncedSearch,

              status,

              priority,

              assigned_admin_id:
                ADMIN_ID,

              limit: 30
            }
          }
        );

      const newTickets =
        res.data.data || [];

      setTickets(prev =>

        reset
          ? newTickets
          : [
            ...prev,
            ...newTickets
          ]
      );

      setCursor(
        res.data.next_cursor
      );

      setHasMore(
        !!res.data.next_cursor
      );

    } catch (err) {

      console.error(err);

      alert(
        err?.response?.data?.error
        ||
        "Failed to fetch tickets"
      );

    } finally {

      setLoading(false);
    }
  };

  /* ======================================================
     INITIAL LOAD
  ====================================================== */

  useEffect(() => {

    fetchTickets(true);

    fetchAdmins();

  }, [
    debouncedSearch,
    status,
    priority
  ]);

  /* ======================================================
     AUTO REFRESH
  ====================================================== */

  useEffect(() => {

    const interval =
      setInterval(() => {

        fetchTickets(true);

      }, 30000);

    return () =>
      clearInterval(interval);

  }, [
    debouncedSearch,
    status,
    priority
  ]);

  /* ======================================================
     SCROLL PAGINATION
  ====================================================== */

  const handleScroll = () => {

    const el =
      containerRef.current;

    if (
      !el
      ||
      loading
      ||
      !hasMore
    ) {
      return;
    }

    if (
      el.scrollTop
      + el.clientHeight
      >=
      el.scrollHeight - 50
    ) {

      fetchTickets();
    }
  };

  /* ======================================================
     FETCH ATTACHMENT
  ====================================================== */

  const fetchAttachment =
    async (id) => {

      try {

        const res =
          await axios.get(
            `${API}/attachment/${id}`,
            {
              headers,
              responseType:
                "blob"
            }
          );

        return URL.createObjectURL(
          res.data
        );

      } catch {

        return null;
      }
    };

  /* ======================================================
     OPEN TICKET
  ====================================================== */

  const openTicket = async (
    id
  ) => {

    try {

      const res =
        await axios.get(
          `${API}/ticket/${id}`,
          { headers }
        );

      setSelectedTicket(
        res.data
      );

      setModalOpen(true);

    } catch (err) {

      console.error(err);

      alert(
        err?.response?.data?.error
        ||
        "Failed to load ticket"
      );
    }
  };

  /* ======================================================
     LOAD ATTACHMENTS
  ====================================================== */

  useEffect(() => {

    const loadAttachments =
      async () => {

        if (
          !selectedTicket
        ) {
          return;
        }

        const map = {};

        for (
          const a
          of
          selectedTicket.attachments
        ) {

          if (
            /\.(jpg|jpeg|png|gif|webp)$/i
              .test(a.file_name)
          ) {

            const url =
              await fetchAttachment(
                a.attachment_id
              );

            if (url) {

              map[
                a.attachment_id
              ] = url;
            }
          }
        }

        setAttachmentUrls(map);
      };

    if (modalOpen) {

      loadAttachments();
    }

  }, [
    modalOpen,
    selectedTicket
  ]);

  /* ======================================================
     BODY LOCK
  ====================================================== */

  useEffect(() => {

    document.body.classList.toggle(
      "zt_modal_lock",
      modalOpen
    );

  }, [modalOpen]);

  /* ======================================================
     STATUS CHANGE
  ====================================================== */

  const changeStatus =
    async (
      id,
      status
    ) => {

      try {

        await axios.post(
          `${API}/ticket/${id}/status`,
          { status },
          { headers }
        );

        await openTicket(id);

        await fetchTickets(true);

      } catch (err) {

        console.error(err);

        alert(
          err?.response?.data?.error
          ||
          "Status update failed"
        );
      }
    };

  /* ======================================================
     PRIORITY CHANGE
  ====================================================== */

  const changePriority =
    async (
      id,
      priority
    ) => {

      try {

        await axios.post(
          `${API}/ticket/${id}/priority`,
          { priority },
          { headers }
        );

        await openTicket(id);

        await fetchTickets(true);

      } catch (err) {

        console.error(err);

        alert(
          err?.response?.data?.error
          ||
          "Priority update failed"
        );
      }
    };

  /* ======================================================
     ESCALATE
  ====================================================== */

  const escalate =
    async (id) => {

      try {

        const res =
          await axios.post(
            `${API}/ticket/${id}/escalate`,
            {},
            { headers }
          );

        alert(
          res.data.message
        );

        await openTicket(id);

        await fetchTickets(true);

      } catch (err) {

        console.error(err);

        alert(
          err?.response?.data?.error
          ||
          "Escalation failed"
        );
      }
    };

  /* ======================================================
     DE ESCALATE
  ====================================================== */

  const deEscalate =
    async (id) => {

      try {

        const res =
          await axios.post(
            `${API}/ticket/${id}/de-escalate`,
            {},
            { headers }
          );

        alert(
          res.data.message
        );

        await openTicket(id);

        await fetchTickets(true);

      } catch (err) {

        console.error(err);

        alert(
          err?.response?.data?.error
          ||
          "De-escalation failed"
        );
      }
    };

  /* ======================================================
     REPLY
  ====================================================== */

  const sendReply =
    async (id) => {

      if (
        !replyMessage.trim()
      ) {
        return;
      }

      try {

        await axios.post(
          `${API}/ticket/${id}/reply`,
          {
            message:
              replyMessage
          },
          { headers }
        );

        setReplyMessage("");

        await openTicket(id);

        alert(
          "Reply sent"
        );

      } catch (err) {

        console.error(err);

        alert(
          err?.response?.data?.error
          ||
          "Reply failed"
        );
      }
    };

  /* ======================================================
     NOTE
  ====================================================== */

  const addInternalNote =
    async (id) => {

      if (
        !internalNote.trim()
      ) {
        return;
      }

      try {

        await axios.post(
          `${API}/ticket/${id}/note`,
          {
            note:
              internalNote
          },
          { headers }
        );

        setInternalNote("");

        await openTicket(id);

        alert(
          "Note added"
        );

      } catch (err) {

        console.error(err);

        alert(
          err?.response?.data?.error
          ||
          "Failed to add note"
        );
      }
    };

  /* ======================================================
     REOPEN
  ====================================================== */

  const reopenTicket =
    async (id) => {

      try {

        const res =
          await axios.post(
            `${API}/ticket/${id}/reopen`,
            {},
            { headers }
          );

        alert(
          res.data.message
        );

        await openTicket(id);

        await fetchTickets(true);

      } catch (err) {

        console.error(err);

        alert(
          err?.response?.data?.error
          ||
          "Reopen failed"
        );
      }
    };

  /* ======================================================
     UNASSIGN
  ====================================================== */

  const unassignTicket =
    async (id) => {

      try {

        const res =
          await axios.post(
            `${API}/ticket/${id}/unassign`,
            {},
            { headers }
          );

        alert(
          res.data.message
        );

        await openTicket(id);

        await fetchTickets(true);

      } catch (err) {

        console.error(err);

        alert(
          err?.response?.data?.error
          ||
          "Unassign failed"
        );
      }
    };

  /* ======================================================
     ASSIGN
  ====================================================== */

  const assignTicket =
    async (
      ticketId,
      adminId
    ) => {

      try {

        await axios.post(
          `${API}/ticket/${ticketId}/assign`,
          {
            admin_id:
              adminId
          },
          { headers }
        );

        await openTicket(
          ticketId
        );

        await fetchTickets(true);

        alert(
          "Assignment updated"
        );

      } catch (err) {

        console.error(err);

        alert(
          err?.response?.data?.error
          ||
          "Assignment failed"
        );
      }
    };

  /* ======================================================
     ACTIONS
  ====================================================== */

  const getAllowedActions =
    (ticket) => {

      const actions = [];

      const status =
        ticket.status;

      if (
        status === "open"
      ) {

        actions.push(
          "in_progress",
          "closed"
        );
      }

      if (
        status === "in_progress"
      ) {

        actions.push(
          "waiting",
          "resolved",
          "closed"
        );
      }

      if (
        status === "waiting"
      ) {

        actions.push(
          "in_progress",
          "closed"
        );
      }

      if (
        status === "resolved"
      ) {

        actions.push(
          "closed"
        );
      }

      return actions;
    };

  /* ======================================================
     RENDER
  ====================================================== */

  return (

    <div className="support-page">

      {/* ===================================================
          HEADER
      =================================================== */}

      <div className="support-header">

        <h2>
          My Tickets
        </h2>

        <div className="support-filters">

          <input
            className="support-search"
            placeholder="Search ticket..."
            value={search}
            onChange={(e) =>
              setSearch(
                e.target.value
              )
            }
          />

          <select
            className="support-select"
            value={status}
            onChange={(e) =>
              setStatus(
                e.target.value
              )
            }
          >

            <option value="">
              Status
            </option>

            <option value="open">
              Open
            </option>

            <option value="in_progress">
              In Progress
            </option>

            <option value="waiting">
              Waiting
            </option>

            <option value="resolved">
              Resolved
            </option>

            <option value="closed">
              Closed
            </option>

          </select>

          <select
            className="support-select"
            value={priority}
            onChange={(e) =>
              setPriority(
                e.target.value
              )
            }
          >

            <option value="">
              Priority
            </option>

            <option value="low">
              Low
            </option>

            <option value="normal">
              Normal
            </option>

            <option value="high">
              High
            </option>

          </select>

        </div>

      </div>

      {/* ===================================================
          TABLE
      =================================================== */}

      <div
        className="support-table-wrap"
        ref={containerRef}
        onScroll={handleScroll}
      >

        <table className="support-table">

          <thead>

            <tr>

              <th>ID</th>

              <th>Queue</th>

              <th>Subject</th>

              <th>Source</th>

              <th>Priority</th>

              <th>Status</th>

              <th>SLA</th>

              <th>Actions</th>

              <th></th>

            </tr>

          </thead>

          <tbody>

            {tickets.map((t) => (

              <tr
                key={t.ticket_id}
              >

                <td>
                  #{t.ticket_id}
                </td>

                <td>
                  {t.queue_name || "—"}
                </td>

                <td>
                  {t.subject}
                </td>

                <td>
                  {t.source_name}
                </td>

                <td>

                  <span
                    className={`support-priority ${t.priority}`}
                  >
                    {t.priority}
                  </span>

                </td>

                <td>

                  <span
                    className={`support-status ${t.status}`}
                  >
                    {t.status}
                  </span>

                </td>

                <td>

                  {t.sla_breached ? (

                    <span className="support-badge is-breached">
                      BREACHED
                    </span>

                  ) : (

                    <span className="support-badge is-sla-safe">
                      OK
                    </span>

                  )}

                </td>

                {/* <td>

                  {t.escalation_level > 0 && (

                    <span
                      className={`zt_escalation l${t.escalation_level}`}
                    >
                      L{
                        t.escalation_level
                      }
                    </span>

                  )}

                </td> */}

                <td>

                  <button
                    className="support-table-btn"
                    onClick={() =>
                      openTicket(
                        t.ticket_id
                      )
                    }
                  >
                    <FaEye />
                    View
                  </button>

                </td>

              </tr>
            ))}

          </tbody>

        </table>

      </div>

      {/* ===================================================
          MODAL
      =================================================== */}

      {modalOpen
        &&
        selectedTicket
        &&

        ReactDOM.createPortal(

          <div
            className="support-modal-overlay"
            onClick={() =>
              setModalOpen(false)
            }
          >

            <div
              className="support-modal"
              onClick={(e) =>
                e.stopPropagation()
              }
            >

              {/* ============================================
                  HEADER
              ============================================ */}

              <div className="support-modal-header">

                <h3>

                  Ticket #
                  {
                    selectedTicket
                      .ticket
                      .ticket_id
                  }

                </h3>

                <button
                  className="support-modal-close"
                  onClick={() =>
                    setModalOpen(false)
                  }
                >
                  ✕
                </button>

              </div>

              {/* ============================================
                  BODY
              ============================================ */}

              <div className="support-modal-body">

                {/* ========================================
                    INFO
                ======================================== */}

                <div className="support-ticket-info">

                  <p>
                    <b>Queue:</b>{" "}
                    {
                      selectedTicket
                        .ticket
                        .queue_name
                    }
                  </p>

                  <p>
                    <b>Subject:</b>{" "}
                    {
                      selectedTicket
                        .ticket
                        .subject
                    }
                  </p>

                  <p>
                    <b>Status:</b>{" "}
                    {
                      selectedTicket
                        .ticket
                        .status
                    }
                  </p>

                  <p>
                    <b>Priority:</b>{" "}
                    {
                      selectedTicket
                        .ticket
                        .priority
                    }
                  </p>

                  <p>
                    <b>Source:</b>{" "}
                    {
                      selectedTicket
                        .ticket
                        .source_name
                    }
                  </p>

                  <p>
                    <b>Escalation:</b>{" "}
                    L{
                      selectedTicket
                        .ticket
                        .escalation_level
                    }
                  </p>

                </div>

                {/* ========================================
                    ACTIONS
                ======================================== */}

                <div className="support-actions">

                  {getAllowedActions(
                    selectedTicket.ticket
                  ).includes(
                    "in_progress"
                  ) && (

                      <button className="support-primary-btn"
                        onClick={() =>
                          changeStatus(
                            selectedTicket.ticket.ticket_id,
                            "in_progress"
                          )
                        }
                      >
                        Start
                      </button>

                    )}

                  {getAllowedActions(
                    selectedTicket.ticket
                  ).includes(
                    "waiting"
                  ) && (

                      <button className="support-primary-btn"
                        onClick={() =>
                          changeStatus(
                            selectedTicket.ticket.ticket_id,
                            "waiting"
                          )
                        }
                      >
                        Waiting
                      </button>

                    )}

                  {getAllowedActions(
                    selectedTicket.ticket
                  ).includes(
                    "resolved"
                  ) && (

                      <button className="support-primary-btn"
                        onClick={() =>
                          changeStatus(
                            selectedTicket.ticket.ticket_id,
                            "resolved"
                          )
                        }
                      >
                        Resolve
                      </button>

                    )}

                  {getAllowedActions(
                    selectedTicket.ticket
                  ).includes(
                    "closed"
                  ) && (

                      <button className="support-primary-btn"
                        onClick={() =>
                          changeStatus(
                            selectedTicket.ticket.ticket_id,
                            "closed"
                          )
                        }
                      >
                        Close
                      </button>

                    )}

                  {selectedTicket.ticket.status === "closed" && (

                    <button className="support-primary-btn"
                      onClick={() =>
                        reopenTicket(
                          selectedTicket.ticket.ticket_id
                        )
                      }
                    >
                      Reopen
                    </button>

                  )}

                  {selectedTicket.ticket.status !== "closed"
                    &&
                    selectedTicket.ticket.status !== "resolved" && (

                      <button className="support-primary-btn"
                        onClick={() =>
                          changePriority(
                            selectedTicket.ticket.ticket_id,
                            "high"
                          )
                        }
                      >
                        High Priority
                      </button>

                    )}

                  {selectedTicket.ticket.status !== "closed"
                    &&
                    selectedTicket.ticket.status !== "resolved"
                    &&
                    selectedTicket.ticket.escalation_level < 2 && (

                      <button className="support-primary-btn"
                        onClick={() =>
                          escalate(
                            selectedTicket.ticket.ticket_id
                          )
                        }
                      >
                        Escalate
                      </button>

                    )}

                  {selectedTicket.ticket.escalation_level > 0
                    &&
                    selectedTicket.ticket.status !== "closed" && (

                      <button className="support-primary-btn"
                        onClick={() =>
                          deEscalate(
                            selectedTicket.ticket.ticket_id
                          )
                        }
                      >
                        De-Escalate
                      </button>

                    )}

                  {/* {selectedTicket.ticket.status !== "closed" && (

                    // <button
                    //   onClick={() =>
                    //     unassignTicket(
                    //       selectedTicket.ticket.ticket_id
                    //     )
                    //   }
                    // >
                    //   Unassign
                    // </button>

                  )} */}

                </div>

                {/* ========================================
                    ASSIGN
                ======================================== */}

                {/* <div className="support-actions">

                  <select
                    className="support-select"
                    defaultValue=""
                    onChange={(e) => {

                      if (
                        e.target.value
                      ) {

                        assignTicket(
                          selectedTicket.ticket.ticket_id,
                          e.target.value
                        );
                      }
                    }}
                  >

                    <option value="">
                      Assign Admin
                    </option>

                    {admins.map(
                      (admin) => (

                        <option
                          key={
                            admin.admin_id
                          }
                          value={
                            admin.admin_id
                          }
                        >
                          {admin.name}
                        </option>

                      )
                    )}

                  </select>

                </div> */}

                {/* ========================================
                    MESSAGES
                ======================================== */}

                <div className="support-chat">

                  {selectedTicket.messages.map(
                    (msg) => (

                      <div
                        key={
                          msg.message_id
                        }
                        className={`support-message ${msg.sender_role}`}
                      >

                        <div className="support-message-meta">

                          <b>
                            {
                              msg.sender_role
                            }
                          </b>

                          <span>

                            {
                              new Date(
                                msg.created_at
                              ).toLocaleString()
                            }

                          </span>

                        </div>

                        <div className="support-message-body">

                          {msg.message}

                        </div>

                      </div>

                    )
                  )}

                </div>

                {/* ========================================
                    ATTACHMENTS
                ======================================== */}

                {selectedTicket.attachments
                  ?.length > 0 && (

                    <div className="support-attachments">

                      <h4>
                        Attachments
                      </h4>

                      {selectedTicket.attachments.map(
                        a => (

                          <div
                            key={a.attachment_id}
                          >

                            {attachmentUrls[
                              a.attachment_id
                            ] ? (

                              <img
                                src={
                                  attachmentUrls[
                                  a.attachment_id
                                  ]
                                }
                                alt=""
                                onClick={() =>
                                  setPreviewFile(
                                    attachmentUrls[
                                    a.attachment_id
                                    ]
                                  )
                                }
                              />

                            ) : (

                              <button
                                onClick={async () => {

                                  const url =
                                    await fetchAttachment(
                                      a.attachment_id
                                    );

                                  if (url) {
                                    window.open(url);
                                  }
                                }}
                              >
                                {a.file_name}
                              </button>

                            )}

                          </div>
                        )
                      )}

                    </div>



                  )}

                {/* ========================================
                    REPLY
                ======================================== */}

                <div className="support-note">

                  <textarea
                    className="support-input"
                    placeholder="Write reply..."
                    value={replyMessage}
                    onChange={(e) =>
                      setReplyMessage(
                        e.target.value
                      )
                    }
                  />

                  <button className="support-table-btn"
                    onClick={() =>
                      sendReply(
                        selectedTicket.ticket.ticket_id
                      )
                    }
                  >
                    Send Reply
                  </button>

                </div>

                {/* ========================================
                    INTERNAL NOTE
                ======================================== */}

                <div className="support-note">

                  <textarea
                    className="support-input"
                    placeholder="Internal note..."
                    value={internalNote}
                    onChange={(e) =>
                      setInternalNote(
                        e.target.value
                      )
                    }
                  />

                  <button className="support-table-btn"
                    onClick={() =>
                      addInternalNote(
                        selectedTicket.ticket.ticket_id
                      )
                    }
                  >
                    Add Note
                  </button>

                </div>

              </div>

            </div>

          </div>,

          document.body
        )
      }

    </div>
  );
}